/* tslint:disable */
/* eslint-disable */
/**
 * Melco Efs APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    EfsMelcoModelsColorListItem,
    EfsMelcoModelsColorListItemFromJSON,
    EfsMelcoModelsColorListItemFromJSONTyped,
    EfsMelcoModelsColorListItemToJSON,
    EfsMelcoModelsCustomWarning,
    EfsMelcoModelsCustomWarningFromJSON,
    EfsMelcoModelsCustomWarningFromJSONTyped,
    EfsMelcoModelsCustomWarningToJSON,
} from './';

/**
 * 
 * @export
 * @interface EfsMelcoModelsColorCollection
 */
export interface EfsMelcoModelsColorCollection {
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoModelsColorCollection
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoModelsColorCollection
     */
    name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EfsMelcoModelsColorCollection
     */
    service_id?: number;
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoModelsColorCollection
     */
    service_name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EfsMelcoModelsColorCollection
     */
    color_count?: number;
    /**
     * 
     * @type {Array<EfsMelcoModelsCustomWarning>}
     * @memberof EfsMelcoModelsColorCollection
     */
    warning_list?: Array<EfsMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {Array<EfsMelcoModelsColorListItem>}
     * @memberof EfsMelcoModelsColorCollection
     */
    color_list?: Array<EfsMelcoModelsColorListItem> | null;
    /**
     * 
     * @type {number}
     * @memberof EfsMelcoModelsColorCollection
     */
    publish_state?: number;
    /**
     * 
     * @type {Date}
     * @memberof EfsMelcoModelsColorCollection
     */
    created_date?: Date;
    /**
     * 
     * @type {Date}
     * @memberof EfsMelcoModelsColorCollection
     */
    publish_date?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof EfsMelcoModelsColorCollection
     */
    updated_date?: Date | null;
}

export function EfsMelcoModelsColorCollectionFromJSON(json: any): EfsMelcoModelsColorCollection {
    return EfsMelcoModelsColorCollectionFromJSONTyped(json, false);
}

export function EfsMelcoModelsColorCollectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): EfsMelcoModelsColorCollection {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'service_id': !exists(json, 'service_id') ? undefined : json['service_id'],
        'service_name': !exists(json, 'service_name') ? undefined : json['service_name'],
        'color_count': !exists(json, 'color_count') ? undefined : json['color_count'],
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(EfsMelcoModelsCustomWarningFromJSON)),
        'color_list': !exists(json, 'color_list') ? undefined : (json['color_list'] === null ? null : (json['color_list'] as Array<any>).map(EfsMelcoModelsColorListItemFromJSON)),
        'publish_state': !exists(json, 'publish_state') ? undefined : json['publish_state'],
        'created_date': !exists(json, 'created_date') ? undefined : (new Date(json['created_date'])),
        'publish_date': !exists(json, 'publish_date') ? undefined : (json['publish_date'] === null ? null : new Date(json['publish_date'])),
        'updated_date': !exists(json, 'updated_date') ? undefined : (json['updated_date'] === null ? null : new Date(json['updated_date'])),
    };
}

export function EfsMelcoModelsColorCollectionToJSON(value?: EfsMelcoModelsColorCollection | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'service_id': value.service_id,
        'service_name': value.service_name,
        'color_count': value.color_count,
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(EfsMelcoModelsCustomWarningToJSON)),
        'color_list': value.color_list === undefined ? undefined : (value.color_list === null ? null : (value.color_list as Array<any>).map(EfsMelcoModelsColorListItemToJSON)),
        'publish_state': value.publish_state,
        'created_date': value.created_date === undefined ? undefined : (value.created_date.toISOString()),
        'publish_date': value.publish_date === undefined ? undefined : (value.publish_date === null ? null : value.publish_date.toISOString()),
        'updated_date': value.updated_date === undefined ? undefined : (value.updated_date === null ? null : value.updated_date.toISOString()),
    };
}


